import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as fromComponents from './components';
import { SharedModule } from '@app/shared/shared.module';

import { FrameToComeRoutingModule } from './frame-to-come-routing.module';
import { FrameToComeComponent } from './frame-to-come.component';
import { GeneratedLabelComponent } from './components/generated-label/generated-label.component';
import { CanLeaveModule } from '@app/can-leave/can-leave.module';

@NgModule({
  imports: [SharedModule, CommonModule, FrameToComeRoutingModule, CanLeaveModule],
  declarations: [FrameToComeComponent, ...fromComponents.components, GeneratedLabelComponent],
  exports: [FrameToComeComponent, ...fromComponents.components],
})
export class FrameToComeModule {}
